export enum SearchPageEvent {
    SEARCH_PAGE_CONTENT_DATA_UPDATED = 'searchPage:content:data:updated'
}
